import { QueryClient } from '@tanstack/react-query'
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister'
import { persistQueryClient } from '@tanstack/react-query-persist-client'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 30,
      retry: 1,
      gcTime: 1000 * 60 * 60 * 24, // 24h - keep cache for offline
    },
    mutations: {
      retry: 1,
    },
  },
})

// Persist query cache to localStorage for offline support
const persister = createSyncStoragePersister({
  storage: window.localStorage,
  key: 'aime-query-cache',
})

persistQueryClient({
  queryClient,
  persister,
  maxAge: 1000 * 60 * 60 * 24, // 24h
})
